import { createGraphic } from "./graphic-creator";

let text, richText;

export function getTextBounds(params) {
    return text || (text = createGraphic("text", {})), text.initAttributes(params), 
    text.AABBBounds;
}

export function getRichTextBounds(params) {
    return richText || (richText = createGraphic("richtext", {})), richText.setAttributes(params), 
    richText.AABBBounds;
}
//# sourceMappingURL=bounds.js.map
